import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth } from '~/routes/components/AuthProvider';
import TableComponent from '~/components/TableComponent';
import Layout from '~/components/Layout';
interface TradingActivitiesProps {
  tradingActivities: any,
  onChange: (data: any) => void,
  isFetchingData: boolean,
  tradingOptions: any[]
  dataFilterActivities: any
}

const defaultFilter = {
  page: 0,
  status: 'completed',
  rows: 10
}

const TradingActivities: React.FC<TradingActivitiesProps> = (props) => {
  const [tradingActivities, setTradingActivities] = useState(null)
  const { t } = useTranslation()
  const [dataFiltered, setDataFiltered] = useState(defaultFilter)
  const { systemData: { amountUnit, amountVolume, amountPrice } } = useAuth()

  const priceLabel = `(${amountPrice == 'e' ? '€' : '€ Ct'}/${amountVolume > 1 ? amountVolume : ''}${amountUnit})`

  const tableColumnHeaders = [
    {
      name: t('Procurement month'),
      key: 'date',
      type: 'dateRibbon',
      format: 'MMM YYYY'
    },
    {
      name: t('Fixed price {{priceLabel}}', { priceLabel }),
      key: 'price',
      info: t('Fixed price which was offered by the dairy within the trading slot.'),
      type: 'no-unit-number'
    },
    {
      name: t('Offered amount (in {{amountUnit}})', { amountUnit }),
      key: 'amount',
      type: 'number'
    },
    {
      name: t('Fixed price amount (in {{amountUnit}})', { amountUnit }),
      key: 'confirmedAmount',
      info: t('The amount your dairy has already confirmed for the respective trading month.'),
      type: 'number'
    },
    {
      name: t('Offer date'),
      type: 'date',
      info: t('Date and time when you have submitted your offered amount within the trading slot.'),
      key: 'createdAt',
      format: 'DD.MM.YYYY HH:mm'
    },
    {
      name: t('Confirmation date'),
      type: 'date',
      info: t('Date and time when your dairy has accepted your offered amount totally, partially or not at all within the trading slot (fixed price volume).'),
      key: 'confirmationDate',
      format: 'DD.MM.YYYY HH:mm'
    },
    {
      name: t('Trading slot ID'),
      key: 'tradingSlotUniqueId'
    }
  ]

  useEffect(() => {
    if (JSON.stringify(dataFiltered) !== JSON.stringify(props.dataFilterActivities)) {
      props.onChange(dataFiltered)
    }
  }, [dataFiltered])

  useEffect(() => {
    if (props.tradingActivities) {
      setTradingActivities(props.tradingActivities)
    }
  }, [props.tradingActivities])

  function renderContent() {
    return <>
      <TableComponent
        isFetchingData={props.isFetchingData}
        animated
        tableColumnHeaders={tableColumnHeaders}
        dataFiltered={dataFiltered}
        rows={rows}
        total={filtered}
        handleChangeDataFiltered={(data) => setDataFiltered(data)}
      />
    </>
  }

  function renderTradingActivities() {
    return renderContent()
  }

  const { filtered, rows } = tradingActivities ? tradingActivities : { filtered: 0, rows: [] }

  return <Layout
    title={t('Trading activities')}
    fontSizeHeader={'18px'}
    childContainerSize={'auto'}
  >
    {tradingActivities && <div>
      {renderTradingActivities()}
    </div>}
  </Layout>
}
export default TradingActivities
